<template>
	<div class="sb_make_doc">
		<div class="row">
			<div class="col-lg-12">
				<div class="panel">
					<make_doc_title title="Додати звіт про роботу"></make_doc_title>

					<div class="panel-container show">
						<div class="panel-content">

							<div class="template p-2">
								<label class="form-label" for="dt_select">
									Дата: *
								</label>

								<div class="select_step">
									<date-picker
										value-type="format"
										v-model="form.date_report"
										:lang="d_lang"
										format="DD-MM-YYYY"
										:confirm="false"
										:disabled="isEditMode"
										:first-day-of-week="1">

									</date-picker>
								</div>
							</div>


							<div class="template p-2">
								<service_select
									@on_service_set="set_service_id"
									:active_id="parseInt(form.service_id)"
								>
								</service_select>
							</div>


							<div class="template p-2">
								<label class="form-label" for="payment_online">
									Введiть коментар
								</label>

								<div class="select_step">
									<b-textarea v-model="form.comment" :rows="5"></b-textarea>
								</div>
							</div>

							<div class="template p-2">
								<b-container fluid class="pl-1">
									<div class="action_field pb-2 mb-2 row fw-500 border-bottom border-1">
										<div class="col-1 np_hd text-left">
											№
										</div>
										<div class="col-2 text-center">
											Початок
										</div>
										<div class="col-2 text-center">
											Закінчення
										</div>
										<div class="col-5 text-center">
											Опис виконаної роботи
										</div>
										<div class="col-2 text-center">
											Тривалість
										</div>
									</div>
									<div class="after_change">
										<div class="action_field row flex-nowrap align-items-center pb-2"
											 v-for="(row,idx) in form.work_items">
											<div class="np col-1 text-left">{{ idx + 1 }}</div>

											<div class="field_insert" :class="item.class"
												 v-for="(item,idx2) in row">
												<div class="filed_inside" v-if="!exclusionName.includes(item.name)">
													<b-form-input
														v-if="item.is_time_pick"
														:key="'t_' + idx + '_' + idx2"
														v-model="item.value"
														type="time"
														class="m-0"
														placeholder="HH:mm"
														@input="changeTime(idx, item)"
													></b-form-input>
													<!--													<b-form-timepicker-->
													<!--														v-if="item.is_time_pick"-->
													<!--														:key="'t_'.idx2" v-model="item.value"-->
													<!--														:no-icon="true"-->
													<!--														class="custom-timepicker"-->
													<!--														placeholder="HH:mm"-->
													<!--														@input="changeTime(item)"-->
													<!--													>-->
													<!--													</b-form-timepicker>-->

													<b-form-input
														v-if="!item.is_time_pick && !item.is_editor"
														:key="'input_' + idx + '_' + idx2"
														v-bind:placeholder=item.text
														v-model="item.value"
														class="w-100 m-0"
													>
													</b-form-input>
												</div>
												<div class="text-center text-nowrap text-truncate"
													 v-if="item.name === 'time_diff'">
													{{ item.value }}
												</div>

											</div>

											<div class="remove_row" @click="remove_row(idx)">
												<i class="fa fa-trash active color-danger-800 cursor-pointer"
												   aria-hidden="true"></i>
											</div>
											<div class="clr"></div>
										</div>
										<div class="control title_">
											<button class="btn btn-success " @click="add_row()">Додати</button>
										</div>
									</div>
								</b-container>
							</div>


							<div class="mt-5 d-flex flex-row flex-nowrap align-items-center overflow-hidden">
								<button class="btn btn-lg btn-outline-primary waves-effect waves-themed"
										:class="can_save ? 'btn-outline-success' : 'btn-outline-danger'"
										v-on:click="save_doc" :disabled=!can_save>
								<span class="fal"
									  :class="{'fa-check mr-1' : can_save, 'fa-exclamation-triangle' : !can_save}"></span>
									Зберегти
								</button>

								<button v-if="isEditMode" class="ml-3 btn btn-lg btn-outline-primary"
										@click.prevent="closeDoc">
									Закрити
								</button>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import Make_doc_title from "../../shared/helpers/make_doc_title.vue";
import Service_select from "../../shared/select/service_select.vue";
import Organization_select from "../../shared/select/organization_select.vue";
import DatePicker from 'vue2-datepicker';

export default {
	name: "report_doc",
	props: {
		item: {
			type: Object,
			required: false,
			default: null
		},
		linkMenu: {
			type: String,
			required: false,
			default: '/zvity-pro-robotu/workreports?doc_type=0'
		}
	},
	components: {
		Organization_select,
		Service_select,
		Make_doc_title,
		DatePicker,
	},
	data() {
		return {
			form: {
				"id": 0,
				"imc_state": 0,
				"date_report": "",
				"service_id": 0,
				"comment": "",
				"work_items": [],
			},
			exclusionName: [
				'tab_id',
				'imc_state',
				'time_diff'
			],
			deleteItems: [],
		}
	},
	created() {
		if (this.item) {
			this.form.id = this.item?.id ?? 0;
			this.form.date_report = this.getDateFromString(this.item?.date_report ?? '');
			this.form.service_id = this.item?.service_id ?? 0;
			this.form.comment = this.item?.comment ?? '';
			const table = this.item?.table ?? [];
			table.forEach(item => {
				let arr_push = JSON.parse(JSON.stringify(this.work_fields));
				arr_push.forEach(itemWork => {
					this.setDataToItemWork(itemWork, item);
					if (itemWork.name === 'time_diff') {
						const startTime = arr_push.find(field => field.name === 'time_start');
						const endTime = arr_push.find(field => field.name === 'time_end');
						itemWork.value = this.fillDiffTimeValue(startTime, endTime);
					}
				})
				this.form.work_items.push(arr_push);
			})
		} else {
			this.form.date_report = this.getCurrentDay();
		}
	},
	methods: {
		getCurrentDay() {
			const today = new Date();

			const day = String(today.getDate()).padStart(2, '0');
			const month = String(today.getMonth() + 1).padStart(2, '0'); // Місяці з 0 до 11
			const year = today.getFullYear();

			return `${day}-${month}-${year}`;
		},
		getDateFromString(dateString) {
			const [year, month, day] = dateString.split("-").map(Number);
			const date = new Date(year, month - 1, day);
			const pad = n => String(n).padStart(2, '0');
			return `${pad(day)}-${pad(month)}-${year}`;
		},
		getTimeFormat(timeString) {
			const [hour, minutes, seconds] = timeString.split(':').map(Number);
			const pad = n => String(n).padStart(2, '0');
			return `${pad(hour)}:${pad(minutes)}`;
		},
		setDataToItemWork(itemWork, item) {

			if (itemWork.name === 'time_start') {
				itemWork.value = this.getTimeFormat(item?.time_from ?? '');
			}
			if (itemWork.name === 'time_end') {
				itemWork.value = this.getTimeFormat(item?.time_to ?? '');
			}
			if (itemWork.name === 'description') {
				itemWork.value = item?.description ?? '';
			}
			if (itemWork.name === 'tab_id') {
				itemWork.value = item?.id ?? '';
			}
			if (itemWork.name === 'imc_state') {
				itemWork.value = item?.imc_state ?? '';
			}
		},

		closeDoc() {
			window.close();
		},

		set_service_id(item_id) {
			if (parseInt(item_id) > 0) {
				this.form.service_id = parseInt(item_id);
			} else {
				this.form.service_id = 0;
			}
		},

		fillDiffTimeValue(startTime, endTime) {
			if (startTime.value && endTime.value) {
				const [startHours, startMinutes] = startTime.value.split(":").map(Number);
				const [endHours, endMinutes] = endTime.value.split(":").map(Number);

				const startDate = new Date(0, 0, 0, startHours, startMinutes);
				const endDate = new Date(0, 0, 0, endHours, endMinutes);

				if (endDate > startDate) {
					let diff = (endDate - startDate) / (1000 * 60);

					const hours = Math.floor(Math.abs(diff) / 60);
					const minutes = Math.abs(diff) % 60;

					return hours.toString().padStart(2, "0") + ' год. ' + minutes.toString().padStart(2, "0") + 'хв.';
				} else {
					return 'Не вірний період';
				}
			}
		},

		changeTime(idx, item) {
			const findElement = JSON.parse(JSON.stringify(this.form.work_items[idx]));
			if (!findElement) {
				return;
			}
			const findItem = findElement.find(field => field.name === item.name);
			if (!findItem) {
				return;
			}
			findItem.value = item.value;
			const startTime = findElement.find(field => field.name === 'time_start');
			const endTime = findElement.find(field => field.name === 'time_end');
			const time_diff = findElement.find(field => field.name === 'time_diff');
			time_diff.value = this.fillDiffTimeValue(startTime, endTime);
			this.$set(this.form.work_items, idx, findElement)
			// this.form.work_items.forEach((field, index) => {
			// 	console.log(index, field[0].name, field[0].value, field[1].name, field[1].value, field[3].name, field[3].value)
			// })

		},
		add_row() {
			let arr_push = JSON.parse(JSON.stringify(this.work_fields));
			this.form.work_items.push(arr_push);
		},

		remove_row(idx) {
			const findItem = this.form.work_items.find((item, index) => index === idx);
			this.deleteItems.push(JSON.parse(JSON.stringify(findItem)));
			this.form.work_items.splice(idx, 1);
		},

		calculate_time_diff(idx) {

		},

		async save_doc() {
			const dataRequest = JSON.parse(JSON.stringify(this.form));

			const work_items = JSON.parse(JSON.stringify(this.form.work_items)).map(row => {
					const res = row.reduce((res, item) => {
						res[item.name] = item.value;
						return res;
					}, {})
					return res;
				}
			);
			const delete_items = JSON.parse(JSON.stringify(this.deleteItems)).map(row => {
					const res = row.reduce((res, item) => {
						res[item.name] = item.value;
						return res;
					}, {})
					if (res.imc_state !== null) {
						res.imc_state = -1;
					}
					return res;
				}
			);

			dataRequest.work_items = [...work_items, ...delete_items];

			IMC_CORE.hideloading();
			await axios.post('/index.php?option=com_imc_report&task=doc.save_doc&format=json',
				dataRequest,
				{
					headers: {"Content-Type": "application/json"}
				}
			)
				.then(({data}) => {
					if (data?.status === "operation_fail") {
						EventBus.$emit('show_toast', {
							err: data?.message,
							type: "danger",
							title: 'Помилка збереження звіту'
						});
						return;
					}
					EventBus.$emit('show_toast', {err: null, type: "success", title: 'Звіт збережено'});

					window.location.href = this.linkMenu;
				}).catch(err => {
					console.log(err);
					const message = err?.response?.data?.message ?? null;
					if (message) {
						EventBus.$emit('show_toast', {err: message, type: "danger", title: 'Помилка збереження звіту'});
					} else {
						EventBus.$emit('show_toast', {err: '', type: "danger", title: 'Помилка збереження звіту'});
					}
				});

		}
	},

	computed: {
		timeDiff() {

		},

		work_fields() {
			return [
				{
					name: 'time_start',
					text: 'Початок',
					value: '',
					class: 'col-2',
					is_editor: false,
					is_time_pick: true
				},
				{
					name: 'time_end',
					text: 'Закінчення',
					value: '',
					class: 'col-2',
					is_editor: false,
					is_time_pick: true
				},
				{
					name: 'description',
					text: 'Опис виконаної роботи',
					value: '',
					class: 'col-5 w-100',
					is_editor: false,
					is_time_pick: false
				},
				{
					name: 'time_diff',
					text: 'Тривалість',
					value: '',
					class: 'col-2 p-0',
					is_editor: false,
					is_time_pick: false
				},
				{
					name: 'tab_id',
					text: '',
					value: 0,
					class: '',
					is_editor: false,
					is_time_pick: false
				},
				{
					name: 'imc_state',
					text: '',
					value: 0,
					class: '',
					is_editor: false,
					is_time_pick: false
				},
			]
		},

		d_lang() {
			return this.get_datepickLang();
		},

		can_save() {
			if (!parseInt(this.form.service_id) > 0) {
				return false;
			}

			if (!this.form.work_items.length > 0) {
				return false;
			}

			return true;
		},
		isEditMode() {
			return this.item !== null;
		},
	}
}
</script>


<style scoped>
.np {
	max-width: 50px;
	font-size: 14px;
}

.np_hd {
	max-width: 50px;
}

</style>